import { GenericCardListPage } from 'src/Features/GenericCardListPage/GenericCardListPage'
import { SortOrder } from 'src/Types/SortOrder'

import { AppPage } from 'src/Types/AppPage'

export const TrackCircuitCardsPage = () => {
  return <GenericCardListPage route={AppPage.TrackCircuitsCards} initialSortOrder={SortOrder.Alphabetical} />
}
